import CloseIcon from '@mui/icons-material/Close';
import EmailIcon from '@mui/icons-material/Email';
import ErrorIcon from '@mui/icons-material/Error';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import LockResetOutlinedIcon from '@mui/icons-material/LockResetOutlined';
import PersonOutlineOutlinedIcon from '@mui/icons-material/PersonOutlineOutlined';
import PhoneAndroidIcon from '@mui/icons-material/PhoneAndroid';
import NoInternetIcon from '../../../components/NetworkStatus/NoInternetIcon';
import LockIcon from '@mui/icons-material/Lock';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { InputAdornment } from '@mui/material';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Backdrop from '@mui/material/Backdrop';
import AppLoader from '../../../components/AppLoader/AppLoader';
import Grid from '@mui/material/Grid';
import IconButton from '@mui/material/IconButton';
import TextField from '../../../components/SanitizedTextField/SanitizedTextField';
import { useFormik } from 'formik';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import CheckPermissions from '../../../authorization/authorization';
import { signIn, stopLoading, setUserData, setSelectedAdminCompanyCode, signOut } from '../../../features/authentication/authenticationSlice';
import { persistor } from '../../../store';
import { updateOC } from '../../../features/officeCodeForName/officeCodeForName';
import { fetchInstallmentProvisions } from '../../../features/provisions/installmentProvisions';
import eOpsLogo from '../../../images/eops.png';
import captcha from '../../../images/g3.png';
import pitcLogo from '../../../images/pitcLogo.png';
import usLogo from '../../../images/usLogo.png';
import { AllSubDivisions } from '../../../network/APIs/APIs';
import { loginSchema } from "../../../schemas/login";
import { forgotpasswordSchema } from "../../../schemas/forgot";
import './login.scss';
import {
  markLandingLogoIntro,
  mountLandingIntroCover,
  shouldPlayLandingLogoIntro,
} from '../../../components/LandingLogoIntro/LandingLogoIntro';
import { fetchAuth } from '../../../features/mdm/authorization';
import { Snackbar, Alert } from '@mui/material';
import * as Yup from "yup";
import { BulkDistributionTheft, damagedMeter, DelayedBillingNewConnection, DetectionBill, electricFire, ElectricityTheft, fluctuation, imageExtensions, InstalledTransformerMeterWireTheft, lineFault, lowVoltageLongTerm, lowVoltageShortTerm, MeterPosition, NonDeliveryofBill, otherComplaintsArray, otherComplaintsArrayCommerical, others, passwordRegex, powerOutage } from '../../../utils/PortalName';
import { Dialog, DialogContent } from '@mui/material';
import { cfpBaseUrl } from '../../../network/urls';
import Error from "../../../components/error/error";
import MfaStep from './MfaStep';
import DistributionCompanySelector from './DistributionCompanySelector';
import {
  shouldShowMfaStep,
  fetchMfaQrSetup,
  verifyMfaOtp,
} from '../../../network/mfaApi';
import { allCompaniesAPI } from '../../../services/Functions';
import { getAdminCompanyCodeForData, isDiscoAdminUser, isEnabledDiscoCompany, isAdminCompanySessionActive, isAdminCompanyPromptPending, isBrowserPageReload, readPersistedAdminCompanyCode, clearAdminCompanySelection, clearAdminCompanyPromptPending, markAdminCompanyPromptPending, writeLastAdminCompanyPreference, persistAdminCompanySelectionToStorage, DEFAULT_DISCO_COMPANY_CODE } from '../../../utils/adminCompany';
import {
  assertInternetConnection,
  NO_INTERNET_MESSAGE,
  normalizeNetworkError,
} from '../../../utils/networkConnectivity';
import useNetworkStatus from '../../../hooks/useNetworkStatus';

const Login = () => {

  //#region constants and states
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { userId, token, code, hierarchy, loading, error, permissions, roleTypeId, roleTypeName, roleId, companyCode, selectedAdminCompanyCode } = useSelector((state) => state.auth);
  const persistRehydrated = useSelector((state) => state._persist?.rehydrated ?? false);
  const UserId = userId;
  const [isLoading, setIsLoading] = React.useState(true);
  const [splashExiting, setSplashExiting] = React.useState(false);
  const [isLocalLoading, setIsLocalLoading] = React.useState(false);
  const [showPassword, setShowPassword] = React.useState(false);
  const [showError, setShowError] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [captchaInput, setCaptchaInput] = useState('');
  const [userToken, setUserToken] = useState('');
  const [showChangePasswordPopup, setShowChangePasswordPopup] = useState(false);
  const [showForgotPasswordPopup, setShowForgotPasswordPopup] = useState(false);
  const [forgotPasswordError, setForgotPasswordError] = useState('');
  const [showOldPassword, setShowOldPassword] = React.useState(false);
  const [showNewPassword, setShowNewPassword] = React.useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false);
  const handleClickShowOldPassword = () => setShowOldPassword((prev) => !prev);
  const handleClickShowNewPassword = () => setShowNewPassword((prev) => !prev);
  const handleClickShowConfirmPassword = () => setShowConfirmPassword((prev) => !prev);
  const [showSuccessSnackbar, setShowSuccessSnackbar] = useState(false);
  const [successSnackbarMessage, setSuccessSnackbarMessage] = useState('Updated Successfully');
  const [apiError, setApiError] = useState('')
  const [showMfa, setShowMfa] = useState(false);
  const [pendingLoginData, setPendingLoginData] = useState(null);
  const [mfaQrSrc, setMfaQrSrc] = useState(null);
  const [mfaManualSecret, setMfaManualSecret] = useState('');
  const [mfaQrLoading, setMfaQrLoading] = useState(false);
  const [mfaQrError, setMfaQrError] = useState('');
  const [mfaVerifyLoading, setMfaVerifyLoading] = useState(false);
  const [mfaVerifyError, setMfaVerifyError] = useState('');
  const [mfaUserId, setMfaUserId] = useState('');
  const [showCompanySelection, setShowCompanySelection] = useState(false);
  const [companyList, setCompanyList] = useState([]);
  const [selectedCompanyForLogin, setSelectedCompanyForLogin] = useState('');
  const [companySelectionLoading, setCompanySelectionLoading] = useState(false);
  const [companiesFetchLoading, setCompaniesFetchLoading] = useState(false);
  const [companySelectionError, setCompanySelectionError] = useState('');
  const { isOffline, refresh: retryNetworkCheck, isChecking: isRetryingNetwork } = useNetworkStatus();

  const showLoginError = (message) => {
    const normalized = normalizeNetworkError(message, 'Login failed');
    setErrorMessage(normalized);
    setShowError(true);
  };

  const handleNetworkRetry = async () => {
    const isConnected = await retryNetworkCheck();
    if (isConnected) {
      setShowError(false);
      setErrorMessage('');
      setApiError('');
      dispatch(stopLoading());
    } else {
      showLoginError(NO_INTERNET_MESSAGE);
    }
  };

  useEffect(() => {
    if (!isOffline && errorMessage === NO_INTERNET_MESSAGE) {
      setShowError(false);
      setErrorMessage('');
    }
  }, [isOffline, errorMessage]);

  const initialValues = {
    UserName: "",
    Password: "",
    iv_old_password: "",
    iv_new_password: "",
    iv_confirm_password: ""
  };
  const errorCloses = () => {
    // setComplaintsError("");
    setApiError("")
  };

  useEffect(() => {
    if (token && roleTypeId == 1) {
      dispatch(fetchInstallmentProvisions())
    } else if (token && roleTypeId == 2) {
      dispatch(fetchAuth())
    }
  }, [token])

  const [captchaNo, setCaptchaNo] = useState(generateCaptcha())
  //#endregion

  //#region formik
  // const { values, errors, touched, handleBlur, handleChange, handleSubmit } = useFormik({
  //   initialValues,
  //   validationSchema: loginSchema,
  //   onSubmit: async (values) => {
  //     setIsLocalLoading(true);
  //     dispatch(signIn(values))
  //   },
  // });

  const callGovtDeptCodesAPI = async (token) => {
    try {
      const formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      const response = await fetch(cfpBaseUrl + "sco/getGovtDepartList", requestOptions);
      const result = await response.json();

      if (result.status === "200") {
        // setGovtDeptCodes(result.data);
        localStorage.setItem("govtDeptCodes", JSON.stringify(result.data)); // ✅ Save to localStorage
      } else {
      }
    } catch (e) {
    }
  };
  const callStandardClassificaitionCodesAPI = async (token) => {
    try {
      const formdata = new FormData();
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);

      const requestOptions = {
        method: 'POST',
        body: formdata,
        headers: myHeaders,
        redirect: 'follow',
      };

      const response = await fetch(cfpBaseUrl + "demandNotice/getClassificationCodes", requestOptions);
      const result = await response.json();

      if (result.status === "200") {
        // setGovtDeptCodes(result.data);
        localStorage.setItem("govtClassFeCodes", JSON.stringify(result.data));
      } else {
      }
    } catch (e) {
    }
  };

  const finalizeSuccessfulLogin = async (data) => {
    const authToken = data.token;
    const isAdmin = isDiscoAdminUser(data.code, data.roleId);
    // Arm landing logo intro as soon as login succeeds
    markLandingLogoIntro();
    if (isAdmin) {
      clearAdminCompanySelection();
      dispatch(setSelectedAdminCompanyCode(""));
      setShowCompanySelection(false);
      setCompanyList([]);
      setSelectedCompanyForLogin('');
      setCompanySelectionError('');
      markAdminCompanyPromptPending();
      // Stop full-page loader before disco popup opens (avoids double loaders)
      setIsLocalLoading(false);
      dispatch(stopLoading());
    } else {
      // Non-admin: keep Sign In loader until subdivisions load + navigate
      setIsLocalLoading(true);
    }
    setShowMfa(false);
    setPendingLoginData(null);
    setMfaQrSrc(null);
    setMfaManualSecret('');
    setMfaQrError('');
    setMfaVerifyError('');
    dispatch(setUserData(data));
    if (authToken) {
      await callGovtDeptCodesAPI(authToken);
      await callStandardClassificaitionCodesAPI(authToken);
    }
    if (isAdmin) {
      setIsLocalLoading(false);
    }
  };

  const loginFormik = useFormik({
    initialValues,
    validationSchema: loginSchema,
    onSubmit: async (values) => {
      setIsLocalLoading(true);
      setErrorMessage("");
      setShowError(false);
      setMfaUserId(values.UserName || '');

      try {
        await assertInternetConnection();

        const resultAction = await dispatch(signIn(values));
        const today = new Date().toISOString().split("T")[0];
        localStorage.setItem("appDate", today);
        const data = resultAction.payload;

        if (resultAction.type === 'auth/signIn/rejected') {
          setIsLocalLoading(false);
          showLoginError(data || 'Login failed');
          return;
        }

        const token = data.token;
        setUserToken(token);

        const isPasswordChangeRequired =
          data.isPasswordChangeRequired === true ||
          data.isPasswordChangeRequired === 'True';

        if (isPasswordChangeRequired) {
          setIsLocalLoading(false);
          passwordChangeFormik.setFieldValue('iv_old_password', values.Password);
          setShowChangePasswordPopup(true);
          return;
        }

        if (shouldShowMfaStep(data)) {
          setPendingLoginData(data);
          if (data?.requiresQRCode && data?.qrCodeImageBase64String) {
            setMfaQrSrc(`data:image/png;base64,${data.qrCodeImageBase64String}`);
          }
          setShowMfa(true);
          setMfaQrError('');
          setMfaVerifyError('');
          setIsLocalLoading(false);
          return;
        }

        await finalizeSuccessfulLogin(data);

      } catch (error) {
        setIsLocalLoading(false);
        showLoginError(error);
      }

    },
  });

  const handleMfaVerify = async (otp) => {
    setMfaVerifyLoading(true);
    setMfaVerifyError('');
    try {
      const userForMfa =
        pendingLoginData?.userId ||
        pendingLoginData?.userName ||
        mfaUserId ||
        loginFormik.values?.UserName;
      if (!userForMfa) {
        setMfaVerifyError('UserId not found for MFA verification.');
        return;
      }
      const { status, ok, message, data: body } = await verifyMfaOtp({
        userId: userForMfa,
        otp,
        isLoggedInFromMobile: '1',
      });
      if (String(status) === '200' || ok) {
        const verifiedLoginData = {
          ...(body || {}),
          token: body?.token || pendingLoginData?.token || userToken,
        };

        const isPasswordChangeRequiredAfterVerify =
          verifiedLoginData?.isPasswordChangeRequired === true ||
          verifiedLoginData?.isPasswordChangeRequired === 'True';
        if (isPasswordChangeRequiredAfterVerify) {
          setUserToken(verifiedLoginData?.token || userToken || '');
          setIsLocalLoading(false);
          passwordChangeFormik.setFieldValue('iv_old_password', loginFormik.values.Password);
          setShowMfa(false);
          setPendingLoginData(null);
          setMfaQrSrc(null);
          setMfaManualSecret('');
          setMfaQrError('');
          setMfaVerifyError('');
          setShowChangePasswordPopup(true);
          return;
        }

        if (!isDiscoAdminUser(verifiedLoginData.code, verifiedLoginData.roleId)) {
          setIsLocalLoading(true);
        }
        await finalizeSuccessfulLogin(verifiedLoginData);
      } else {
        setMfaVerifyError(message || body?.message || 'Verification failed.');
      }
    } catch (e) {
      setMfaVerifyError(normalizeNetworkError(e, 'Verification failed.'));
    } finally {
      setMfaVerifyLoading(false);
    }
  };

  const handleMfaCancel = () => {
    setShowMfa(false);
    setPendingLoginData(null);
    setMfaQrSrc(null);
    setMfaManualSecret('');
    setMfaQrError('');
    setMfaVerifyError('');
    setMfaUserId('');
  };


  const callLogoutAPI = async () => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", token);


      const requestOptions = {
        method: "PUT",
        headers: myHeaders,
        keepalive: true,
      };

      await fetch(cfpBaseUrl + "customerFaciliationPortal/logOut", requestOptions)
        .then((response) => response.json())
        .then((result) => { })
        .catch(() => { });
    } catch (e) {

    }
  }


  const { values, errors, touched, handleBlur, handleChange, handleSubmit, resetForm } = loginFormik;
  const passwordChangeFormik = useFormik({
    initialValues,
    validationSchema: Yup.object({
      iv_old_password: Yup.string().required("Old password is required"),
      iv_new_password: Yup.string().matches(passwordRegex, "Password does not meet the requirements").required("Password is required"),
      iv_confirm_password: Yup.string().oneOf([Yup.ref('iv_new_password'), null], 'Password and Confirm password must match').required("Confirm password is required"),
    }),
    onSubmit: async (values, { resetForm }) => {
      const myHeaders = new Headers();
      myHeaders.append("Authorization", userToken);

      const formdata = new FormData();
      formdata.append("userName", userId);
      formdata.append("newPassword", values.iv_new_password);
      formdata.append("currentPassword", values.iv_old_password);

      var requestOptions = {
        method: "PUT",
        body: formdata,
        headers: myHeaders,
        redirect: "follow",
      };

      await fetch(
        cfpBaseUrl + "customerFaciliationPortal/updateUserPassword",
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          // if (result.status === "200") {
          //   resetForm();
          //   setUserToken('');
          //   setShowChangePasswordPopup(false)
          //   loginFormik.resetForm();
          //   resetCaptcha();
          //   setShowSuccessSnackbar(true);
          //   // window.location.reload();
          // }
          if (result.status === "200") {
            resetForm();
            setUserToken('');
            loginFormik.resetForm();
            resetCaptcha();

            setSuccessSnackbarMessage('Updated Successfully');
            setShowSuccessSnackbar(true);

            // Delay closing the dialog by 300ms
            setTimeout(() => {
              setShowChangePasswordPopup(false);
            }, 300);
          }
          else if (result.status === "400") {
            setApiError(result.message)
          }
        })
        .catch(() => { });
    },
  });

  const forgotPasswordFormik = useFormik({
    initialValues: {
      Username: '',
      PhoneLast4: '',
    },
    validationSchema: forgotpasswordSchema,
    validateOnChange: false,
    validateOnBlur: false,
    onSubmit: async (formValues, { resetForm }) => {
      setForgotPasswordError('');
      try {
        const myHeaders = new Headers();
        myHeaders.append('Authorization', '');
        myHeaders.append('Content-Type', 'application/json');

        const raw = JSON.stringify({
          userId: formValues.Username.trim(),
          phoneNo: formValues.PhoneLast4.trim(),
        });

        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: raw,
          redirect: 'follow',
        };

        // Exact endpoint: {cfpBaseUrl}customerFaciliationPortal/forgotPassword
        // e.g. http://175.107.33.109:8038/customerFaciliationPortal/forgotPassword
        const response = await fetch(
          `${cfpBaseUrl}customerFaciliationPortal/forgotPassword`,
          requestOptions
        );
        const resultText = await response.text();
        let result = {};
        try {
          result = resultText ? JSON.parse(resultText) : {};
        } catch (e) {
          setForgotPasswordError(resultText || 'Unexpected response from server.');
          return;
        }

        if (result.status === '200' || result.status === 200) {
          resetForm();
          setShowForgotPasswordPopup(false);
          setSuccessSnackbarMessage(
            result.message ||
            'Password has been sent to your registered mobile number.'
          );
          setShowSuccessSnackbar(true);
          return;
        }

        setForgotPasswordError(
          result.message ||
          'We could not verify your details. Please check your username and mobile digits.'
        );
      } catch (error) {
        setForgotPasswordError(
          normalizeNetworkError(error) || 'Something went wrong. Please try again.'
        );
      }
    },
  });

  const forgotPhoneDigits = forgotPasswordFormik.values.PhoneLast4 || '';
  const canSubmitForgotPassword =
    Boolean(forgotPasswordFormik.values.Username?.trim()) &&
    /^\d{4}$/.test(forgotPhoneDigits) &&
    !forgotPasswordFormik.isSubmitting;

  const resetNewPassword = passwordChangeFormik.values.iv_new_password || '';
  const resetConfirmPassword = passwordChangeFormik.values.iv_confirm_password || '';
  const resetPasswordChecks = {
    length: resetNewPassword.length >= 8,
    upper: /[A-Z]/.test(resetNewPassword),
    lower: /[a-z]/.test(resetNewPassword),
    number: /\d/.test(resetNewPassword),
    special: /[@$!%*?&#]/.test(resetNewPassword),
  };
  const canSubmitResetPassword =
    Object.values(resetPasswordChecks).every(Boolean) &&
    Boolean(resetConfirmPassword) &&
    resetNewPassword === resetConfirmPassword &&
    !passwordChangeFormik.isSubmitting;
  //#endregion

  //#region functions
  function generateCaptcha() {
    const operators = ['+'];
    const num1 = Math.floor(Math.random() * 20);
    const num2 = Math.floor(Math.random() * 20);
    const operator = operators[Math.floor(Math.random() * operators.length)];

    return `${num1} ${operator} ${num2}`;
  }


  const resetCaptcha = () => {
    setCaptchaNo(generateCaptcha());
    setCaptchaVerified(false);
    setCaptchaInput('');
  };
  const handleCloseChangePasswordPopup = () => {
    setShowChangePasswordPopup(false);
    passwordChangeFormik.resetForm();
    loginFormik.resetForm();
    resetCaptcha();
    setApiError('');
  };

  const handleOpenForgotPasswordPopup = () => {
    setForgotPasswordError('');
    forgotPasswordFormik.resetForm({
      values: {
        Username: values.UserName || '',
        PhoneLast4: '',
      },
    });
    setShowForgotPasswordPopup(true);
  };

  const handleCloseForgotPasswordPopup = () => {
    setShowForgotPasswordPopup(false);
    setForgotPasswordError('');
    forgotPasswordFormik.resetForm();
  };

  const handleClickShowPassword = () => {
    setShowPassword((show) => !show);
  }

  const handleMouseDownPassword = (event) => {
    event.preventDefault();
  };

  const handleCaptchaChange = (e) => {
    const value = e.target.value.trim();
    setCaptchaInput(value);

    // Evaluate the math expression safely
    try {
      const answer = eval(captchaNo); // e.g. "6 - 5" => 1

      if (value === answer.toString()) {
        setCaptchaVerified(true);
      } else {
        setCaptchaVerified(false);
      }


    } catch (error) {
      setCaptchaVerified(false);
    }
  };


  //#endregion

  //#region useEffects
  useEffect(() => {
    const exitTimer = setTimeout(() => {
      setSplashExiting(true);
    }, 1650);
    const hideTimer = setTimeout(() => {
      setIsLoading(false);
    }, 2050);
    return () => {
      clearTimeout(exitTimer);
      clearTimeout(hideTimer);
    };
  }, []);

  useEffect(() => {
    const html = document.documentElement;
    const rootEl = document.getElementById('root');
    html.setAttribute('data-boot', 'login');
    document.body.style.backgroundColor = '#0b3d6e';
    if (rootEl) {
      rootEl.style.backgroundColor = '#0b3d6e';
    }

    return () => {
      html.removeAttribute('data-boot');
      document.body.style.backgroundColor = '';
      if (rootEl) {
        rootEl.style.backgroundColor = '';
      }
    };
  }, []);

  useEffect(() => {
    if (error) {
      showLoginError(error);
      setIsLocalLoading(false);
    }
  }, [error])

  useEffect(() => {
    dispatch(stopLoading())
  }, [])

  useEffect(() => {
    if (!showMfa || !pendingLoginData?.token) return;
    let cancelled = false;
    (async () => {
      setMfaQrLoading(true);
      setMfaQrError('');
      setMfaQrSrc(null);
      setMfaManualSecret('');
      try {
        const { ok, data: body, status } = await fetchMfaQrSetup(pendingLoginData.token);
        if (cancelled) return;
        if (String(status) === '200' && (body?.data || body?.qrCodeImageBase64String)) {
          const d = body?.data || body;
          let qr = null;
          if (d.qrCodeImageBase64String) qr = `data:image/png;base64,${d.qrCodeImageBase64String}`;
          else if (d.qrImageBase64) qr = `data:image/png;base64,${d.qrImageBase64}`;
          else if (d.qrUrl) qr = d.qrUrl;
          setMfaQrSrc((prev) => prev || qr);
          setMfaManualSecret(d.manualSecret || d.secret || '');
        } else if (!ok) {
          setMfaQrError(body?.message || 'Unable to load QR. API path may need configuration.');
        }
      } catch (e) {
        if (!cancelled) setMfaQrError(e.message || 'QR request failed.');
      } finally {
        if (!cancelled) setMfaQrLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [showMfa, pendingLoginData]);

  useEffect(() => {
    if (!persistRehydrated) {
      return;
    }

    if (isBrowserPageReload()) {
      clearAdminCompanyPromptPending();
      setShowCompanySelection(false);
      setCompanyList([]);
      setSelectedCompanyForLogin('');
      setCompanySelectionError('');
    }
  }, [persistRehydrated]);

  useEffect(() => {
    if (!persistRehydrated) {
      return;
    }

    const loadSubDivisionsAndNavigate = async (authToken, officeHierarchy, companyCodeForData) => {
      if (!authToken) return;
      const isAdmin = isDiscoAdminUser(code, roleId);
      try {
        setShowCompanySelection(false);
        if (isAdmin) {
          // Admin: no full-page Sign In loader — soft cover + landing intro
          setIsLocalLoading(false);
          dispatch(stopLoading());
          markLandingLogoIntro();
          mountLandingIntroCover();
        } else {
          // Non-admin: keep AppLoader running through data load
          setIsLocalLoading(true);
        }
        await AllSubDivisions(authToken, officeHierarchy, companyCodeForData);
        // Stop login loader first, then hand off to landing logo animation
        setIsLocalLoading(false);
        dispatch(stopLoading());
        markLandingLogoIntro();
        mountLandingIntroCover();
        navigate('/landingpage', { state: { playLogoIntro: true } });
      } catch (e) {
        setIsLocalLoading(false);
      }
    };

    const promptCompanySelection = async () => {
      setIsLocalLoading(false);
      dispatch(stopLoading());
      setShowCompanySelection(true);
      setCompaniesFetchLoading(true);
      setCompanySelectionError('');
      try {
        const companies = await allCompaniesAPI(token, cfpBaseUrl);
        const list = (companies || []).filter(
          (item) => item.companyCode && Number(item.companyCode) > 10
        );
        if (!list.length) {
          setCompanySelectionError('No distribution companies available.');
          return;
        }
        setCompanyList(list);
        setSelectedCompanyForLogin(DEFAULT_DISCO_COMPANY_CODE);
      } catch (e) {
        setCompanySelectionError('Unable to load companies. Please try again.');
      } finally {
        setCompaniesFetchLoading(false);
      }
    };

    if (!userId || !token) {
      setShowCompanySelection(false);
      return;
    }

    if (!isDiscoAdminUser(code, roleId)) {
      setShowCompanySelection(false);
      const companyCodeForData = getAdminCompanyCodeForData(
        code,
        roleId,
        selectedAdminCompanyCode,
      );
      if (companyCodeForData) {
        loadSubDivisionsAndNavigate(token, hierarchy, companyCodeForData);
      }
      return;
    }

    const sessionActive = isAdminCompanySessionActive();
    const storedCompanyCode = sessionActive ? readPersistedAdminCompanyCode() : "";
    const effectiveSelectedCompany = sessionActive
      ? (selectedAdminCompanyCode || storedCompanyCode)
      : "";

    if (sessionActive && !selectedAdminCompanyCode && storedCompanyCode) {
      dispatch(setSelectedAdminCompanyCode(storedCompanyCode));
      dispatch(updateOC({ officeCode: storedCompanyCode }));
      return;
    }

    const companyCodeForData = getAdminCompanyCodeForData(
      code,
      roleId,
      effectiveSelectedCompany,
    );

    if (companyCodeForData) {
      setShowCompanySelection(false);
      clearAdminCompanyPromptPending();
      dispatch(updateOC({ officeCode: companyCodeForData }));
      loadSubDivisionsAndNavigate(token, hierarchy, companyCodeForData);
      return;
    }

    if (!companySelectionLoading && !showCompanySelection) {
      promptCompanySelection();
    }
  }, [
    userId,
    token,
    code,
    hierarchy,
    roleId,
    selectedAdminCompanyCode,
    persistRehydrated,
    navigate,
    dispatch,
    showCompanySelection,
    companySelectionLoading,
  ]);

  const handleCompanySelect = (companyCode) => {
    if (!isEnabledDiscoCompany(companyCode)) {
      return;
    }
    setSelectedCompanyForLogin(companyCode);
    setCompanySelectionError('');
  };

  const handleCompanySelectionConfirm = async (companyCodeOverride) => {
    const companyToUse = String(companyCodeOverride || selectedCompanyForLogin || '');
    if (!companyToUse) {
      setCompanySelectionError('Please select a company.');
      return;
    }
    if (!isEnabledDiscoCompany(companyToUse)) {
      setCompanySelectionError('This distribution company is not available yet.');
      return;
    }
    setSelectedCompanyForLogin(companyToUse);
    setCompanySelectionLoading(true);
    setCompanySelectionError('');
    try {
      writeLastAdminCompanyPreference(companyToUse);
      persistAdminCompanySelectionToStorage(companyToUse);
      dispatch(setSelectedAdminCompanyCode(companyToUse));
      dispatch(updateOC({ officeCode: companyToUse }));
      clearAdminCompanyPromptPending();
      markLandingLogoIntro();
      mountLandingIntroCover();
      await AllSubDivisions(token, hierarchy, companyToUse);
      setShowCompanySelection(false);
      navigate('/landingpage', { state: { playLogoIntro: true } });
    } catch (e) {
      setCompanySelectionError('Unable to load company data. Please try again.');
    } finally {
      setCompanySelectionLoading(false);
    }
  };

  useEffect(() => {
    if (code) {
      const effectiveCode = getAdminCompanyCodeForData(code, roleId, selectedAdminCompanyCode) || code;
      dispatch(updateOC({ officeCode: effectiveCode }))
    }
  }, [code, roleId, selectedAdminCompanyCode, dispatch])

  //#endregion

  const loginDisplayError = showError
    ? (errorMessage || normalizeNetworkError(error, 'Login failed'))
    : '';
  const isLoginNetworkError = loginDisplayError === NO_INTERNET_MESSAGE;

  return (
    <Grid
      className='login-background'
      style={{ backgroundColor: '#0b3d6e', minHeight: '100vh' }}
    >
      {isLoading ? (
        <div
          className={`login-splash${splashExiting ? ' login-splash--exit' : ''}`}
          aria-label="Loading eOps"
          role="status"
          style={{ backgroundColor: '#0b3d6e' }}
        >
          <div className="login-splash__card">
            <img src={eOpsLogo} alt="eOps" className="login-splash__logo" />
            <div className="login-splash__bar" aria-hidden>
              <span className="login-splash__bar-fill" />
            </div>
          </div>
        </div>
      ) : (
        <form className="loginForm loginForm--enter">
          <div className="login-header">
            <div className='logoContainer'>
              <img src={eOpsLogo} alt="eOps" className='logo' />
            </div>
            {isOffline && (
              <button
                type="button"
                className="login-header__offline-icon"
                onClick={handleNetworkRetry}
                disabled={isRetryingNetwork}
                aria-label="No internet connection. Check and retry"
              >
                {isRetryingNetwork ? (
                  <AppLoader size={28} />
                ) : (
                  <NoInternetIcon size={64} />
                )}
              </button>
            )}
          </div>
          {showError && !isLoginNetworkError && (
            <div className="login-error-banner">
              <div className="login-error-banner__content">
                <ErrorIcon className="login-error-banner__error-icon" />
                <p className="login-error-banner__message">{loginDisplayError}</p>
              </div>
              <div className="login-error-banner__actions">
                <CloseIcon className="login-error-banner__close" onClick={() => { setShowError(false) }} />
              </div>
            </div>
          )}
          <Box className='form-fields'>
            <TextField
              margin="none"
              className='textfield'
              required
              fullWidth
              value={values.UserName}
              name="UserName"
              onChange={handleChange}
              onBlur={handleBlur}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className='input-adornments'>
                    <EmailIcon className='icon' />
                  </InputAdornment>
                ),
                autoComplete: "off"
              }}
              id="username"
              label=""
              autoComplete="off"
              placeholder='Username'
              size='small'
            />
            {errors.UserName && touched.UserName ? (
              <p className="form-error">{errors.UserName}</p>
            ) : null}
            <TextField
              type={showPassword ? 'text' : 'password'}
              margin="none"
              className='textfield'
              required
              fullWidth
              value={values.Password}
              name="Password"
              autoComplete="off"
              onChange={handleChange}
              onBlur={handleBlur}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start" className='input-adornments'>
                    <LockIcon className='icon' />
                  </InputAdornment>
                ),
                autoComplete: 'off',
                endAdornment: (
                  <InputAdornment position="end" className='input-adornments'>
                    <IconButton
                      aria-label="toggle password visibility"
                      onClick={handleClickShowPassword}
                      onMouseDown={handleMouseDownPassword}
                      edge="end"
                    >
                      {showPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                )
              }}
              id="password"
              label=""
              placeholder='Password'
              size='small'
            />
            {errors.Password && touched.Password ? (
              <p className="form-error">{errors.Password}</p>
            ) : null}

            <div className="captcha-row">
              <button
                type="button"
                className="captcha"
                title="Refresh captcha"
                onClick={(e) => {
                  e.preventDefault();
                  setCaptchaNo(generateCaptcha());
                  setCaptchaVerified(false);
                  setCaptchaInput('');
                }}
              >
                <img src={captcha} alt="" className="captcha__refresh" height={22} />
                <span className="captcha__challenge">{captchaNo}</span>
              </button>
              <span className="captcha-row__equals" aria-hidden>
                =
              </span>
              <TextField
                type="text"
                margin="none"
                className="textfield captcha-input"
                required
                fullWidth
                name="Captcha"
                autoComplete="off"
                value={captchaInput}
                onChange={handleCaptchaChange}
                id="captcha"
                label=""
                placeholder="Captcha"
                size="small"
              />
            </div>

            <Button
              type="submit"
              fullWidth
              variant="contained"
              className={`form-button${(!captchaVerified || loading || isLocalLoading) ? ' form-button--disabled' : ''}`}
              onClick={loginFormik.handleSubmit}
              disabled={(!captchaVerified) || loading || isLocalLoading}
            >
              Sign In
            </Button>
            <div className="form-bottom-link">
              <button
                type="button"
                className="forgot-password-link"
                onClick={handleOpenForgotPasswordPopup}
              >
                Forgotten password?
              </button>
            </div>
            <div className="powered-by">
              <div className="powered-by__divider" aria-hidden />
              <div className="logos">
                <img className="usaid" src={usLogo} alt="USAID" />
                <img className="pitc" src={pitcLogo} alt="Power Information Technology Company" />
              </div>
            </div>
          </Box>
        </form>
      )}

      <Dialog
        open={Boolean(showMfa && pendingLoginData)}
        onClose={(event, reason) => {
          if (reason === 'backdropClick' || reason === 'escapeKeyDown') {
            handleMfaCancel();
          }
        }}
        maxWidth={false}
        fullWidth
        scroll="paper"
        className="mfa-setup-dialog"
        sx={{ zIndex: (theme) => theme.zIndex.modal + 100 }}
        BackdropProps={{
          sx: {
            backgroundColor: 'rgba(0, 57, 113, 0.72)',
            backdropFilter: 'blur(3px)',
          },
        }}
        PaperProps={{
          elevation: 12,
          sx: {
            maxWidth: 'min(1120px, calc(100vw - 32px))',
            width: '100%',
            margin: '16px',
            borderRadius: '12px',
            maxHeight: 'calc(100vh - 40px)',
            overflow: 'hidden',
            boxShadow: '0 12px 48px rgba(0, 36, 73, 0.28)',
            border: '1px solid rgba(255, 255, 255, 0.85)',
          },
        }}
      >
        <DialogContent sx={{ p: 0, overflow: 'auto', maxHeight: 'calc(100vh - 40px)' }}>
          {showMfa && pendingLoginData ? (
            <MfaStep
              variant="dialog"
              qrSrc={mfaQrSrc}
              manualSecret={mfaManualSecret}
              qrLoading={mfaQrLoading}
              qrError={mfaQrError}
              verifying={mfaVerifyLoading}
              verifyError={mfaVerifyError}
              onVerify={handleMfaVerify}
              onCancel={handleMfaCancel}
            />
          ) : null}
        </DialogContent>
      </Dialog>

      <DistributionCompanySelector
        open={showCompanySelection}
        companies={companyList}
        selectedCompanyCode={selectedCompanyForLogin}
        onSelectCompany={handleCompanySelect}
        onConfirm={handleCompanySelectionConfirm}
        loading={companySelectionLoading}
        companiesLoading={companiesFetchLoading}
        error={companySelectionError}
      />

      {/* Login only: AppLoader while signing in; off before landing animation */}
      <Backdrop
        sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.modal + 200 }}
        open={Boolean(
          (loading || isLocalLoading) &&
          !showCompanySelection &&
          !showMfa &&
          !shouldPlayLandingLogoIntro()
        )}
      >
        <AppLoader />
      </Backdrop>

      <Dialog
        open={showForgotPasswordPopup}
        onClose={handleCloseForgotPasswordPopup}
        fullWidth
        maxWidth="xs"
        className="forgot-password-dialog"
      >
        <div className="forgot-password-dialog__header">
          <div className="forgot-password-dialog__header-left">
            <span className="forgot-password-dialog__header-icon" aria-hidden>
              <LockResetOutlinedIcon />
            </span>
            <div className="forgot-password-dialog__header-text">
              <h2 className="forgot-password-dialog__title">Forgot Password</h2>
              <p className="forgot-password-dialog__subtitle">
                Password will be sent to your registered mobile no.
              </p>
            </div>
          </div>
          <IconButton
            onClick={handleCloseForgotPasswordPopup}
            className="forgot-password-dialog__close"
            aria-label="Close forgot password"
            size="small"
          >
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent className="forgot-password-dialog__content">
          <form
            autoComplete="off"
            onSubmit={forgotPasswordFormik.handleSubmit}
            className="forgot-password-dialog__form"
          >
            <div className="forgot-password-dialog__hint">
              <InfoOutlinedIcon className="forgot-password-dialog__hint-icon" />
              <p>
                Enter your username and the last 4 digits of your registered mobile number. Your password will be sent to that number.
              </p>
            </div>

            <label className="forgot-password-dialog__label" htmlFor="forgot-username">
              Username
            </label>
            <TextField
              id="forgot-username"
              fullWidth
              size="small"
              name="Username"
              placeholder="Enter your username"
              value={forgotPasswordFormik.values.Username}
              onChange={(e) => {
                setForgotPasswordError('');
                forgotPasswordFormik.setFieldValue('Username', e.target.value);
                if (forgotPasswordFormik.errors.Username) {
                  forgotPasswordFormik.setFieldError('Username', undefined);
                }
              }}
              error={Boolean(
                forgotPasswordFormik.submitCount > 0 &&
                forgotPasswordFormik.errors.Username
              )}
              helperText={
                forgotPasswordFormik.submitCount > 0 &&
                  forgotPasswordFormik.errors.Username
                  ? forgotPasswordFormik.errors.Username
                  : undefined
              }
              FormHelperTextProps={{
                className: 'forgot-password-dialog__helper',
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PersonOutlineOutlinedIcon sx={{ color: '#9aa4b2' }} />
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 1 }}
            />

            <div className="forgot-password-dialog__phone-label-row">
              <label
                className="forgot-password-dialog__label"
                htmlFor="forgot-phone-last4"
              >
                Last 4 digits of mobile
              </label>
              <span
                className={`forgot-password-dialog__digit-count${forgotPhoneDigits.length === 4
                    ? ' forgot-password-dialog__digit-count--ready'
                    : ''
                  }`}
              >
                {forgotPhoneDigits.length}/4
              </span>
            </div>
            <TextField
              id="forgot-phone-last4"
              fullWidth
              size="small"
              name="PhoneLast4"
              placeholder="••••"
              inputProps={{
                maxLength: 4,
                inputMode: 'numeric',
                pattern: '[0-9]*',
                autoComplete: 'off',
              }}
              value={forgotPasswordFormik.values.PhoneLast4}
              onChange={(e) => {
                setForgotPasswordError('');
                const digitsOnly = e.target.value.replace(/\D/g, '').slice(0, 4);
                forgotPasswordFormik.setFieldValue('PhoneLast4', digitsOnly);
                if (forgotPasswordFormik.errors.PhoneLast4) {
                  forgotPasswordFormik.setFieldError('PhoneLast4', undefined);
                }
              }}
              error={Boolean(
                forgotPasswordFormik.submitCount > 0 &&
                forgotPasswordFormik.errors.PhoneLast4
              )}
              helperText={
                forgotPasswordFormik.submitCount > 0 &&
                  forgotPasswordFormik.errors.PhoneLast4
                  ? forgotPasswordFormik.errors.PhoneLast4
                  : undefined
              }
              FormHelperTextProps={{
                className: 'forgot-password-dialog__helper',
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <PhoneAndroidIcon sx={{ color: '#9aa4b2' }} />
                  </InputAdornment>
                ),
              }}
            />

            {forgotPasswordError && (
              <div className="forgot-password-dialog__error" role="alert">
                <Error
                  error={forgotPasswordError}
                  onClose={() => setForgotPasswordError('')}
                  backgroundColor="#FFC0CB"
                  textColor="#bb0303"
                  iconColor="#bb0303"
                />
              </div>
            )}

            <div className="forgot-password-dialog__actions">
              <Button
                type="button"
                variant="text"
                className="forgot-password-dialog__cancel"
                onClick={handleCloseForgotPasswordPopup}
                disabled={forgotPasswordFormik.isSubmitting}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                className="forgot-password-dialog__submit"
                disabled={!canSubmitForgotPassword}
              >
                Send Password
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Backdrop
        open={Boolean(showForgotPasswordPopup && forgotPasswordFormik.isSubmitting)}
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.modal + 300,
          backgroundColor: 'rgba(15, 23, 42, 0.35)',
        }}
      >
        <AppLoader />
      </Backdrop>

      <Dialog
        open={showChangePasswordPopup}
        onClose={() => {
          if (!passwordChangeFormik.isSubmitting) {
            handleCloseChangePasswordPopup();
          }
        }}
        fullWidth
        maxWidth="xs"
        className="forgot-password-dialog reset-password-dialog"
        aria-labelledby="reset-password-dialog-title"
      >
        <div className="forgot-password-dialog__header">
          <div className="forgot-password-dialog__header-left">
            <span className="forgot-password-dialog__header-icon" aria-hidden>
              <LockResetOutlinedIcon />
            </span>
            <div className="forgot-password-dialog__header-text">
              <h2
                id="reset-password-dialog-title"
                className="forgot-password-dialog__title"
              >
                Reset Password
              </h2>
              <p className="forgot-password-dialog__subtitle">
                Create a new password to continue signing in.
              </p>
            </div>
          </div>
          <IconButton
            id="clearPopup"
            onClick={handleCloseChangePasswordPopup}
            className="forgot-password-dialog__close"
            aria-label="Close reset password"
            size="small"
            disabled={passwordChangeFormik.isSubmitting}
          >
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent className="forgot-password-dialog__content">
          <form
            autoComplete="off"
            name="change-password-form"
            onSubmit={passwordChangeFormik.handleSubmit}
            className="forgot-password-dialog__form"
          >
            <input
              type="text"
              name="username"
              autoComplete="username"
              value={UserId}
              readOnly
              hidden
            />

            <div className="reset-password-dialog__warning" role="status">
              <ErrorIcon className="reset-password-dialog__warning-icon" />
              <p>
                Your current password has expired. Please set a new password to
                continue.
              </p>
            </div>

            <label
              className="forgot-password-dialog__label"
              htmlFor="reset-new-password"
            >
              New Password
            </label>
            <TextField
              id="reset-new-password"
              fullWidth
              size="small"
              type={showNewPassword ? 'text' : 'password'}
              name="iv_new_password"
              autoComplete="new-password"
              placeholder="Enter a new password"
              value={passwordChangeFormik.values.iv_new_password}
              onChange={(e) => {
                setApiError('');
                passwordChangeFormik.handleChange(e);
              }}
              onBlur={passwordChangeFormik.handleBlur}
              error={Boolean(
                passwordChangeFormik.touched.iv_new_password &&
                passwordChangeFormik.errors.iv_new_password
              )}
              helperText={
                passwordChangeFormik.touched.iv_new_password &&
                  passwordChangeFormik.errors.iv_new_password
                  ? passwordChangeFormik.errors.iv_new_password
                  : undefined
              }
              FormHelperTextProps={{
                className: 'forgot-password-dialog__helper',
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon sx={{ color: '#9aa4b2' }} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      type="button"
                      onClick={handleClickShowNewPassword}
                      edge="end"
                      size="small"
                      aria-label={
                        showNewPassword ? 'Hide new password' : 'Show new password'
                      }
                      className="reset-password-dialog__eye"
                    >
                      {showNewPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
              sx={{ mb: 0.5 }}
            />

            <ul className="reset-password-dialog__rules" aria-label="Password requirements">
              <li
                className={`reset-password-dialog__rule${resetPasswordChecks.length ? ' reset-password-dialog__rule--met' : ''
                  }`}
              >
                8+ characters
              </li>
              <li
                className={`reset-password-dialog__rule${resetPasswordChecks.upper ? ' reset-password-dialog__rule--met' : ''
                  }`}
              >
                Uppercase
              </li>
              <li
                className={`reset-password-dialog__rule${resetPasswordChecks.lower ? ' reset-password-dialog__rule--met' : ''
                  }`}
              >
                Lowercase
              </li>
              <li
                className={`reset-password-dialog__rule${resetPasswordChecks.number ? ' reset-password-dialog__rule--met' : ''
                  }`}
              >
                Number
              </li>
              <li
                className={`reset-password-dialog__rule${resetPasswordChecks.special ? ' reset-password-dialog__rule--met' : ''
                  }`}
              >
                Special character
              </li>
            </ul>

            <label
              className="forgot-password-dialog__label"
              htmlFor="reset-confirm-password"
            >
              Confirm New Password
            </label>
            <TextField
              id="reset-confirm-password"
              fullWidth
              size="small"
              type={showConfirmPassword ? 'text' : 'password'}
              name="iv_confirm_password"
              autoComplete="new-password"
              placeholder="Re-enter new password"
              value={passwordChangeFormik.values.iv_confirm_password}
              onChange={(e) => {
                setApiError('');
                passwordChangeFormik.handleChange(e);
              }}
              onBlur={passwordChangeFormik.handleBlur}
              error={Boolean(
                passwordChangeFormik.touched.iv_confirm_password &&
                passwordChangeFormik.errors.iv_confirm_password
              )}
              helperText={
                passwordChangeFormik.touched.iv_confirm_password &&
                  passwordChangeFormik.errors.iv_confirm_password
                  ? passwordChangeFormik.errors.iv_confirm_password
                  : undefined
              }
              FormHelperTextProps={{
                className: 'forgot-password-dialog__helper',
              }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <LockIcon sx={{ color: '#9aa4b2' }} />
                  </InputAdornment>
                ),
                endAdornment: (
                  <InputAdornment position="end">
                    <IconButton
                      type="button"
                      onClick={handleClickShowConfirmPassword}
                      edge="end"
                      size="small"
                      aria-label={
                        showConfirmPassword
                          ? 'Hide confirm password'
                          : 'Show confirm password'
                      }
                      className="reset-password-dialog__eye"
                    >
                      {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                    </IconButton>
                  </InputAdornment>
                ),
              }}
            />

            {apiError && (
              <div className="forgot-password-dialog__error" role="alert">
                <Error
                  error={apiError}
                  onClose={errorCloses}
                  backgroundColor="#FFC0CB"
                  textColor="#bb0303"
                  iconColor="#bb0303"
                />
              </div>
            )}

            <div className="forgot-password-dialog__actions">
              <Button
                type="button"
                variant="text"
                className="forgot-password-dialog__cancel"
                onClick={handleCloseChangePasswordPopup}
                disabled={passwordChangeFormik.isSubmitting}
              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                className="forgot-password-dialog__submit"
                disabled={!canSubmitResetPassword}
              >
                Update Password
              </Button>
            </div>
          </form>
        </DialogContent>
      </Dialog>

      <Backdrop
        open={Boolean(showChangePasswordPopup && passwordChangeFormik.isSubmitting)}
        sx={{
          color: '#fff',
          zIndex: (theme) => theme.zIndex.modal + 300,
          backgroundColor: 'rgba(15, 23, 42, 0.35)',
        }}
      >
        <AppLoader />
      </Backdrop>

      <Snackbar
        open={showSuccessSnackbar}
        autoHideDuration={4000}
        onClose={() => setShowSuccessSnackbar(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert
          onClose={() => setShowSuccessSnackbar(false)}
          severity="success"
          sx={{ width: '100%' }}
        >
          {successSnackbarMessage}
        </Alert>
      </Snackbar>

    </Grid>

  );
}

export default Login;
